import { Container, type Ticker } from 'pixi.js';
import type { ViewportLayout } from './Viewport';
import type { BaseScene } from '../scenes/BaseScene';

export class SceneManager {
  private currentScene: BaseScene | null = null;

  public constructor(private readonly sceneRoot: Container) {}

  public changeScene(nextScene: BaseScene): void {
    if (nextScene === this.currentScene) {
      return;
    }

    this.clearCurrentScene();
    this.currentScene = nextScene;
    this.sceneRoot.addChild(nextScene.container);
    nextScene.start();
  }

  public update(ticker: Ticker): void {
    this.currentScene?.update(ticker);
  }

  public resize(layout: ViewportLayout): void {
    this.currentScene?.resize(layout);
  }

  public getCurrentScene(): BaseScene | null {
    return this.currentScene;
  }

  public destroy(): void {
    this.clearCurrentScene();
  }

  private clearCurrentScene(): void {
    if (!this.currentScene) {
      return;
    }

    const scene = this.currentScene;
    this.currentScene = null;

    if (scene.container.parent === this.sceneRoot) {
      this.sceneRoot.removeChild(scene.container);
    }

    scene.destroy();
  }
}
